<template>
  <div class="animated fadeIn">
    <b-card size="sm">
      <div slot="header">
        <i class="icon-note"></i> Set Qty Pengembalian Barang
      </div>

      <b-card-body>
        <b-row>
          <b-col sm="12">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>SPKB</th>
                  <th>Status</th>
                  <th>Driver</th>
                  <th>Penanggung Jawab Faktur</th>
                  <th>Tanggal Pengiriman</th>
                  <th>Tanggal Pembuatan Aktual</th>
                  <th>Tanggal Pembuatan Retur</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{spkb_number}}</td>
                  <td>{{getStatusSPKB}}</td>
                  <td>{{getDriverName}}</td>
                  <td>{{getInvoicePIC}}</td>
                  <td>{{getDeliveryDate}}</td>
                  <td>{{getActualUpdateDate}}</td>
                  <td>{{getReturDate}}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>

        <b-row v-if="!loadingSubmit">
          <b-col sm="12">
            <b-form id="spkbForm" validated novalidate>
              <table class="table table-bordered table-striped table-responsive">
                <thead>
                  <tr>
                      <th rowspan="2" class="th-300px text-center" style="vertical-align: middle;">Nama Produk</th>
                      <th colspan="3" class="text-center">Qty</th>
                      <th colspan="4" class="th-900px text-center" style="vertical-align: middle;">Total</th>
                  </tr>
                  <tr>
                    <!-- <th class="th-300px">Nama Produk</th> -->
                    <th class="text-center">Plan</th>
                    <th class="text-center">Aktual</th>
                    <th class="text-center">Return</th>

                    <th class="text-center">Plan</th>
                    <th class="text-center">Aktual</th>
                    <th class="text-center">Retur</th>
                    <th class="text-center">Fee</th>
                    <!-- <th class="width-250">Total</th> -->
                  </tr>
                </thead>
                <tbody style="width:100%;">
                  <template v-for="(v, index) in spkb">
                    <tr :key="uniqueId('a'+index)">
                      <td><div v-html="v.product_name"/></td>
                      <td class="text-center">{{v.qty_plan}}</td>
                      <td class="text-center">{{v.qty_actual}}</td>
                      <td class="text-center">{{v.qty_retur}}</td>
                      <td class="text-right">Rp. {{formatPrice(v.total_price_plan)}}</td>
                      <td class="text-right">Rp. {{formatPrice(v.total_price_actual)}}</td>
                      <td class="text-right">Rp. {{formatPrice(v.total_price_retur)}}</td>
                      <td class="text-right">Rp. {{formatPrice(v.total_fee)}}</td>
                    </tr>
                  </template>

                  <template>
                    <tr>
                      <td class="text-right">Total</td>
                      <td class="text-center">{{totalQty}}</td>
                      <td class="text-center">{{totalQtyActual}}</td>
                      <td class="text-center">{{totalQtyRetur}}</td>
                      <td class="text-right">Rp. {{formatPrice(totalPricePlan)}}</td>
                      <td class="text-right">Rp. {{formatPrice(totalPriceActual)}}</td>
                      <td class="text-right">Rp. {{formatPrice(totalPriceRetur)}}</td>
                      <td class="text-right">Rp. {{formatPrice(totalFee)}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>

            </b-form>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <loading></loading>
          </b-col>
        </b-row>
      </b-card-body>

      <!-- <b-card-body v-else>
          <b-row>
            <b-col sm="12">
              <p class="text-center">No data available</p>
            </b-col>
          </b-row>
      </b-card-body> -->
    </b-card>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required, between } from "vuelidate/lib/validators";
import loading from "@/templates/Loading.vue";
import _ from "lodash";
import * as moment from "moment";
import "moment/locale/id";

const contains = function(min, max, value) {
  return value >= min || value <= max;
};

export default {
  name: "finance-piutang-detail",
  components: {
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      spkb: [],
      spkb_number: String,
      spkb_retur: [],
      loadingSubmit: false,
      totalQty: 0,
      test: []
    };
  },
  validations: {
    spkb_retur: {
      $each: {
        qty: { required },
        product_id: { required },
        qty_plan: { required },
        qty_actual: { required },
        qty_retur: { required },
        price_plan: { required },
        qty_each_box: {}
      }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    status_spkb() {
      let status_spkb = 0;
      for (let i of this.spkb) {
        status_spkb = parseInt(i.status_spkb);
      }
      return status_spkb;
    },
    totalQtyActual() {
      let total = 0;
      for (let i of this.spkb) {
        total += parseInt(i.qty_actual);
      }
      return total;
    },
    totalQtyRetur() {
      let total = 0;
      for (let i of this.spkb) {
        total += parseInt(i.qty_retur);
      }
      return total;
    },
    totalPricePlan() {
      let totalPrice = 0;
      for (let i of this.spkb) {
        totalPrice += parseInt(i.total_price_plan);
      }
      return totalPrice;
    },
    totalPriceActual() {
      let totalPrice = 0;
      for (let i of this.spkb) {
        totalPrice += parseInt(i.total_price_actual);
      }
      return totalPrice;
    },
    totalPriceRetur() {
      let totalPrice = 0;
      for (let i of this.spkb) {
        totalPrice += parseInt(i.total_price_retur);
      }
      return totalPrice;
    },
    totalFee() {
      let totalFee = 0;
      for (let i of this.spkb) {
        totalFee += parseInt(i.total_fee);
      }
      return totalFee;
    },
    getDriverName() {
      let driver_name = '';
      for (let i of this.spkb) {
        driver_name = i.driver_name;
      }
      return driver_name;
    },
    getInvoicePIC() {
      let invoice_pic = '';
      for (let i of this.spkb) {
        invoice_pic = i.penanggung_jawab_faktur;//(i.invoice_pic_employee_name === null) ? i.invoice_pic_dc_name : i.invoice_pic_employee_name;
      }
      return invoice_pic;
    },
    getDeliveryDate() {
      let delivery_date = '';
      for (let i of this.spkb) {
        delivery_date = moment(i.delivery_date).format('DD MMM YYYY');
      }
      return delivery_date;
    },
    getActualUpdateDate() {
      let actual_date = '';
      for (let i of this.spkb) {
        actual_date = (i.actual_update_time !== null) ? moment(i.actual_update_time).format('DD MMM YYYY') : '-';
      }
      return actual_date;
    },
    getReturDate() {
      let retur_date = '';
      for (let i of this.spkb) {
        retur_date = (i.retur_update_time !== null) ? moment(i.retur_update_time).format('DD MMM YYYY') : '-';
      }
      return retur_date;
    },
    getStatusSPKB() {
      let status = '';
      for (let i of this.spkb) {
        if (i.status === '1') {
          status = 'SPKB Sudah Aktual';
        } else if(i.status === '2') {
          status = 'SPKB Sudah Dikirm';
        } else if(i.status === '3') {
          status = 'SPKB Dibatalkan';
        }
      }
      return  status;
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function(spkb_id) {
      this.loading = true;
      this.getDetailSpkb(spkb_id);
    },
    formatPrice: function(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getDetailSpkb: function(spkb_id) {
      this.axios
        .get("web/product/return-product/detail/" + spkb_id + "/")
        .then(response => {
          let data = response.data.data;
          this.spkb = data;
          data.forEach((value, index) => {
            // this.spkb_retur.push({
            //   qty: 0,
            //   product_id: value.product_id,
            //   qty_plan: value.qty_plan,
            //   qty_actual: value.qty_actual,
            //   qty_retur: value.qty_retur,
            //   price_plan: parseInt(value.price_plan),
            //   qty_each_box: parseInt(value.qty_each_box)
            // });
            this.totalQty += parseInt(value.qty_plan);
          });
        })
        .catch(error => {
          this.expired(error, "Error Messages");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    },
    doSomething: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin memasukkan Qty Retur ?")) {
        this.loadingSubmit = true;
        let reGroup = {};
        reGroup.spkb_number = this.spkb_number;
        reGroup.data = { order_detail: this.spkb_retur };
        this.axios
          .put("web/product/adjust-retur-spkb/", reGroup)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Adjust Retur SPKB",
                message: response.data.message
              });
              this.loadingSubmit = false;
              this.$router.push({ path: "/product-return/all" });
            }
          })
          .catch(error => {
            this.expired(error, "Error Messages");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    back: function() {
      this.$router.go(-1);
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.spkb_number = route[4];
    this.init(route[4]);
  }
};
</script>

<style>
</style>